module.exports = __webpack_public_path__ + "static/media/icnoco_salvado_cereales.35c50644.png";